import routes from 'constants/routes';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { fetchCurrentUserProfile } from 'services/auth';

import { setUserInfo } from 'store/modules/user';

const PrivateRoutes: React.FC<any> = (props) => {
  // eslint-disable-next-line no-shadow
  const { children, setUserInfo } = props;

  const { pathname } = useLocation();

  const  history = useHistory();

  useEffect(() => {
    fetchCurrentUserProfile().then(({ profile }) => {
      setUserInfo(profile);
    }).catch((err)=>{
      console.error(err);
      history.replace(routes.SIGN_IN)

    });
  }, [history, pathname, setUserInfo]);

  return <>{children}</>;
};

export default connect(null, { setUserInfo })(PrivateRoutes);
